export enum AppEventType {
    Info,
    Warning,
    Error,
    Debug
}
